<template>
  <!--
      	作者：kmdshop
      	时间：2019-06-04
      	描述：插件中心-分销-分销设置
      -->
  <div v-loading="loading">
    <el-form size="small" ref="form" :model="form" label-width="180px" v-if="!loading">
      <el-tabs size="small" v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="基础设置" name="basic"></el-tab-pane>
        <!-- <el-tab-pane label="申请协议" name="license"></el-tab-pane> -->
      </el-tabs>

      <!--基础设置-->
      <Basic v-if="activeName == 'basic'" :form="form" :options="options "></Basic>

      <!--申请协议-->
      <License v-if="activeName == 'license'" :form="form"></License>
      <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
    </el-form>
  </div>
</template>
<script>
import SupplyApi from '@/api/supply.js';
import Basic from './part/Basic';
import License from './part/License';
export default {
  components: {
    /*编辑组件*/
    Basic,
    License
  },
  data() {
    return {
      /*是否正在加载*/
      loading:true,
      /*当前选中*/
      activeName: 'basic',
      /*数据对象*/
      form:{},
      options:[]
    };
  },
  created() {
    this.activeName="basic"
    this.getData();
  },
  methods: {

    /*获取数据*/
    getData() {
     let self = this;
      let Params = {};
      SupplyApi.getSetting(Params, true)
        .then(data => {
          let vars = data.data.vars.values;
            self.form = vars;
            if(data.data.vars.gradeList.data){
              self.options = data.data.vars.gradeList.data;
            }
            
            self.loading = false;
        })
        .catch(error => {});
    },
   onSubmit() {
      let self = this;
      let params = self.form
      self.loading = true;
      SupplyApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    handleClick(e) {
      this.activeName = e.name;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/supply/setting/getSetting.vue